import { LOCALES } from "utils/constants";

const translation = {
  [LOCALES.FA]: {
    NEWS_AND_EVENTS: "اخبار و رویدادها",
    NEWS: "اخبار",
    EVENTS: "اعلانات",
    SEARCH: "عبارت خود را جستجو کنید",
    NOT_FOUND: "موردی یافت نشد!",
    BREADCRUMB: [{ title: "اخبار و اعلانات" }],
    NEWS_PUBLISH_DATE: "تاریخ انتشار",
    EVENTS_PUBLISH_DATE: "تاریخ رویداد",
    FAILED: "خطایی وجود دارد",
    FILL_ERROR_MESSAGE: "لطفا فیلد جستجو را وارد نمایید",
    OPTIONS_PLACEHOLDER: "انتخاب کنید",
    NO_OPTIONS: "موردی وجود ندارد",
    OPTIONS: {
      news: [
        {
          label: "همه",
          value: "",
        },
        {
          label: "آموزشی",
          value: "آموزشی",
        },
        {
          label: "پژوهشی",
          value: "پژوهشی",
        },
        {
          label: "عمومی",
          value: "عمومی",
        },
      ],
      events: [
        {
          label: "همه",
          value: "",
        },
        {
          label: "آموزشی",
          value: "آموزشی",
        },
        {
          label: "پژوهشی",
          value: "پژوهشی",
        },
        {
          label: "امور دانشجويي",
          value: "امور دانشجويي",
        },
        {
          label: "كنفرانس / همايش",
          value: "كنفرانس / همايش",
        },
      ],
    },
  },
  [LOCALES.EN]: {
    NEWS_AND_EVENTS: "News And Events",
    NEWS: "News",
    EVENTS: "Events",
    SEARCH: "Search",
    NOT_FOUND: "Not Found!",
    BREADCRUMB: [{ title: "News And Events" }],
    NEWS_PUBLISH_DATE: "Published",
    EVENTS_PUBLISH_DATE: "Published",
    FAILED: "Failed!",
    FILL_ERROR_MESSAGE: "Please Fill The Input",
    OPTIONS_PLACEHOLDER: "Select",
    NO_OPTIONS: "ٔNo Options",
    OPTIONS: {
      news: [
        {
          label: "All",
          value: "",
        },
      ],
      events: [
        {
          label: "All",
          value: "",
        },
      ],
    },
  },
} as const;

export const MAPPED_TAB_URL = {
  news: "news",
  events: "declarations",
  gathering: "conferences",
  speechs: "conferences",
  "اخبار-دانش‌آموختگان": "news",
  "اعلانات-دانش‌آموختگان": "declarations",
  "news-alumni": "news",
  "event-alumni": "declarations",
};

export default translation;
